var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#0069CA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8635 51.7V46.15C22.8635 44.3333 23.1385 42.7917 23.6885 41.525C24.2385 40.2583 25.0551 39.1917 26.1385 38.325C27.2385 37.4417 28.6135 36.6833 30.2635 36.05L36.9135 33.5C38.3635 32.9167 39.4301 32.2 40.1135 31.35C40.8135 30.5 41.1635 29.45 41.1635 28.2C41.1635 26.95 40.7051 25.9 39.7885 25.05C38.8885 24.1833 37.5968 23.75 35.9135 23.75C34.2968 23.75 32.9385 24.1583 31.8385 24.975C30.7551 25.775 30.1301 26.95 29.9635 28.5H23.4135C23.4635 26.2833 24.0385 24.4417 25.1385 22.975C26.2385 21.5083 27.7135 20.4167 29.5635 19.7C31.4135 18.9667 33.4968 18.6 35.8135 18.6C37.9968 18.6 39.9718 19.0167 41.7385 19.85C43.5051 20.6667 44.9051 21.8167 45.9385 23.3C46.9885 24.7667 47.5135 26.4833 47.5135 28.45C47.5135 30.1167 47.2051 31.5833 46.5885 32.85C45.9885 34.1167 45.0718 35.225 43.8385 36.175C42.6051 37.125 41.0468 37.9667 39.1635 38.7L32.4635 41.3C31.1635 41.8 30.2218 42.3583 29.6385 42.975C29.0551 43.575 28.7635 44.3667 28.7635 45.35V46.3H47.3135V51.7H22.8635Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoIcon);
export default __webpack_public_path__ + "static/media/two_icon.24c07095762e7d66f1fcd208510c4fde.svg";
export { ForwardRef as ReactComponent };